<template>
	<div class="page">
		<div class="screenLine">
			<!-- <el-input disabled placeholder="请输入关键字" style="width:240px;margin-right: 16px;"></el-input> -->
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" height="100%">
				<el-table-column label="流程名称" >
					<template slot-scope="props">
						<span>{{props.row.flow_name}}</span>
					</template>
				</el-table-column>
				<el-table-column label="流程分类" >
					<template slot-scope="props">
						<span v-if="props.row.flow_category===1">押金</span>
						<span v-if="props.row.flow_category===3">充值</span>
						<span v-if="props.row.flow_category===2">通用</span>
					</template>
				</el-table-column>
				<el-table-column label="退款日期" >
					<template slot-scope="props">
						<span>{{props.row.duration}}</span>
					</template>
				</el-table-column>
				<el-table-column label="审批人员">
					<template slot-scope="props">
						<div v-for="item in props.row.approve_users" :key="item.id">
							{{item.receive_name}}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="抄送人员">
					<template slot-scope="props">
						<div v-for="item in props.row.copy_users" :key="item.receive_name">
							{{item.receive_name}}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作人">
					<template slot-scope="props">
						<div>{{props.row.operation_info.create.create_user.user_name}}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作日期" >
					<template slot-scope="props">
						<div >{{$public.FTime(props.row.operation_info.create.create_time)}}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="props">
						<el-button type="text" size="mini" @click="edit(props.row)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagePosi">
			<page style="padding:10px 0;" :page="page.page" :total="page.total" :pageSize="page.pageSize" @change="changePage"></page>
		</div>
		<div v-if="drawEditRefundSet_state">
			<drawEditRefundSet :curItem="curItem" @submit="submit_drawEditRefundSet"></drawEditRefundSet>
		</div>
	</div>
</template>
<script>
	import page from "../../../components/page.vue"
	import drawEditRefundSet from "./draw/draw_editRefundSet.vue"
	export default {
		components:{page,drawEditRefundSet},
		data(){
			return{
				tableData:[],
				curItem:{},
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				
				// 修改弹窗
				drawEditRefundSet_state:false,
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.userInfo;
			},
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			//编辑
			edit(row){
				this.curItem = row;
				this.drawEditRefundSet_state = true;
			},
			submit_drawEditRefundSet(){
				this.drawEditRefundSet_state = false;
				this.getTableData();
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let loading=this.$loading();
				let params = {
					"flow_category": 0,
					"status": -1,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": '',
				}
				this.$http.post(process.env.VUE_APP_member+'/api/middleware/RefundAudit/Flow/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			}
		}
	}
</script>
<style scoped lang="scss">
	.page {
		padding: 16px 16px 65px 16px;
		height: 100%;
		box-sizing: border-box;
		position: relative;

		.screenLine {
			display: flex;
			.screenLineR{
				flex: 1;
				display: flex;
				justify-content: flex-end;
				.tabView{
					display: flex;
					align-items: center;
					width: 278px;
					height: 44px;
					background: #E7E7F4;
					border-radius: 10px;
					justify-content: space-around;
					.tabItem{
						width: 90px;
						height: 36px;
						font-size: 14px;
						text-align: center;
						line-height: 36px;
						border-radius: 8px;
					}
					.tabActiveItem{
						width: 90px;
						height: 36px;
						font-size: 14px;
						text-align: center;
						line-height: 36px;
						border-radius: 8px;
						background: #3A6DFF;
						color: #fff;
					}
				}
			}
			.titleSelect{
				width: 130px;
				margin-right: 16px;
			}
		}

		.tableBox {
			padding: 16px;
			border-radius: 8px;
			background-color: #fff;
			box-sizing: border-box;
			margin-top: 16px;
			height: calc(100% - 56px);
		}

		.pagePosi {
			position: absolute;
			bottom: 0;
			left: 16px;
			right: 16px;
			text-align: right;
			background-color: #fff;
			padding: 0 10px;
			border-radius: 8px 8px 0 0;
		}
	}
</style>
